import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import DualListBox from "../../../duallistBox";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../UserPermissionsContext";
import CommonSelect, { Option } from "../../../../core/common/commonSelect";
import { Spin } from "antd";

type Permission = { id: number; name: string };

type Admin = {
  permissions: Array<number>;
  category_name: string | null;
  category_id: number;
};

interface ErrorMessages {
  category_name?: string[];
}


const WizClubEditCategory = () => {
  const routes = all_routes;
  const location = useLocation();
  const { id } = location.state || {};
  console.log(id);
  const navigate = useNavigate();
  const [chosenPermissions, setChosenPermissions] = useState<Permission[]>([]);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [errorMessage, setErrorMessage] = useState<ErrorMessages>({});
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [data, setData] = useState({});

  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const [newAdmin, setNewAdmin] = useState<Admin>({
    category_name: null,
    category_id: 0,
    permissions: [],
  });

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchCategoryData = async (id: string) => {
    const response = await fetch(
      `${webApi}/wizklub/wizklub_categories/${id}`,
      options
    );
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }
    return await response.json();
  };

  // const fetchDispositions = async () => {
  //   const response = await fetch(
  //     `${webApi}/summercamp/dispositions_dropdown/`,
  //     options
  //   );
  //   return await response.json();
  // };

  // const fetchTypeOfTicket = async () => {
  //   const response = await fetch(
  //     `${webApi}/wizklub/type_of_tickets_dropdown/`,
  //     options
  //   );
  //   return await response.json();
  // };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const [categoryData] = await Promise.all([
        // fetchDispositions(),
        // fetchTypeOfTicket(),
        fetchCategoryData(id),
      ]);
      // setDispositions(dispositionsData);
      // setTypeOfTicket(typeOfTicketData);
      setNewAdmin(categoryData);
      // if (categoryData.disposition) {
      //   setSelectedDisposition(
      //     dispositionsData.find(
      //       (d: { student_disposition_id: any }) =>
      //         d.student_disposition_id === categoryData.disposition
      //     )
      //   );
      // }
      // if (categoryData.type_of_ticket) {
      //   setSelectedTypeOfTicket(
      //     typeOfTicketData.find(
      //       (t: { ticket_type_id: any }) =>
      //         t.ticket_type_id === categoryData.type_of_ticket
      //     )
      //   );
      // }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePermissionsChange = (selected: Permission[]) => {
    setNewAdmin({
      ...newAdmin,
      permissions: selected.map((permission) => permission.id),
    });
  };

  useEffect(() => {
    if (!checkPermission("change_wizklubcategory", "wizklubcategory")) {
      navigate(routes.crmLandingPage);
    } else {
      fetchData();
    }
  }, [userPermissions]);

  const updateData = async () => {
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(newAdmin),
    };
    const url = `${webApi}/wizklub/wizklub_categories/${id}/`;
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      const errorData = await response.json();
      setErrorMessage(errorData);
      throw new Error("Network response was not ok");
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading1(true);
    try {
      await updateData();
      navigate(routes.wizklubCategories);
    } catch (error) {
    } finally {
      setIsLoading1(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewAdmin({ ...newAdmin, [name]: value || null });
  };

  // const dispositionOptions = dispositions.map((d) => ({
  //   value: d.student_disposition_id.toString(),
  //   label: d.disposition_name,
  // }));

  // const ticketTypeOptions = typeOfTicket.map((t) => ({
  //   value: t.ticket_type_id.toString(),
  //   label: t.ticket_type,
  // }));

  // const handleDispositionChange = (selected: Option | null) => {
  //   const disposition = dispositions.find(
  //     (d) => d.student_disposition_id === parseInt(selected?.value || "")
  //   );
  //   setSelectedDisposition(disposition || null);
  //   setNewAdmin({
  //     ...newAdmin,
  //     disposition: disposition?.student_disposition_id,
  //   });
  // };

  // const handleTicketTypeChange = (selected: Option | null) => {
  //   const ticketType = typeOfTicket.find(
  //     (t) => t.ticket_type_id === parseInt(selected?.value || "")
  //   );
  //   setSelectedTypeOfTicket(ticketType || null);
  //   setNewAdmin({
  //     ...newAdmin,
  //     type_of_ticket: ticketType?.ticket_type_id,
  //   });
  // };

  useEffect(() => {
    const forms = document.querySelectorAll(
      ".needs-validation"
    ) as NodeListOf<HTMLFormElement>;

    Array.from(forms).forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }
          form.classList.add("was-validated");
        },
        false
      );
    });
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Wizklub Edit Category</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.SummerCampCategories}>Categories</Link>
                  </li>
                  <li className="breadcrumb-item active">Edit Category</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              <div
                className="card"
                style={{
                  width: "70%",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  borderRadius: "10px",
                }}
              >
                {isLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      height: "100vh",
                      paddingTop: "20px",
                    }}
                  >
                    <Spin /> {/* Display loader while loading */}
                  </div>
                ) : (
                  <div className="card-body">
                    <form
                      onSubmit={handleSubmit}
                      className="d-flex flex-column"
                    >
                      <div className="modal-body light-violet-bg d-flex">
                        {/* <div className="mb-3 me-3" style={{ width: "35%" }}>
                        <label className="form-label">Disposition</label>
                        <CommonSelect
                          className="select"
                          options={dispositionOptions}
                          onChange={handleDispositionChange}
                          defaultValue={dispositionOptions.find(
                            (option) =>
                              option.value ===
                              selectedDisposition?.student_disposition_id.toString()
                          )}
                        />
                      </div> */}
                        {/* <div className="mb-3" style={{ flex: "1 1 50%" }}>
                        <label className="form-label">Ticket Type</label>
                        <CommonSelect
                          className="select"
                          options={ticketTypeOptions}
                          onChange={handleTicketTypeChange}
                          defaultValue={ticketTypeOptions.find(
                            (option) =>
                              option.value ===
                              selectedTypeOfTicket?.ticket_type_id.toString()
                          )}
                        />
                      </div> */}
                      </div>

                      <div className="form-group mb-3" style={{ width: "35%" }}>
                        <label className="form-label">Category Name</label>
                        <input
                          type="text"
                          className={`form-control ${
                            errorMessage.category_name ? "is-invalid" : ""
                          }`}
                          name="category_name"
                          placeholder="Category Name"
                          onChange={handleInputChange}
                          value={newAdmin.category_name || ""}
                        />
                         {errorMessage.category_name && (
                        <div className="invalid-feedback">
                          {errorMessage.category_name[0]}
                        </div>
                      )}
                      </div>
                      <div className="modal-footer">
                        <Link
                          className="btn btn-primary"
                          type="submit"
                          to={routes.wizklubCategories}
                          style={{
                            backgroundColor: "lightcoral",
                            color: "white",
                            marginRight: "5px",
                          }}
                        >
                          Cancel
                        </Link>
                        <button
                          className="btn btn-primary"
                          type="submit"
                          disabled={isLoading}
                        >
                          {isLoading1 ? (
                            <i className="spinner-border spinner-border-sm"></i>
                          ) : (
                            <>Save</>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WizClubEditCategory;
